// src/components/BarraProgresso.js
import React from 'react';
import caminhonete from '../assets/caminhao.png';

function BarraProgresso({ etapaAtual }) {
  const etapas = [
    'Identificação',
    'Dados do Cliente',
    'Tipo de Serviço',
    'Detalhes Importantes',
    'Itens',
    'Termo/Contrato',
    'Conclusão'
  ];

  const progresso = (etapaAtual / (etapas.length - 1)) * 100;

  return (
    <div className="mb-4">
      <div className="position-relative" style={{ height: '50px' }}>
        <div className="progress" style={{ height: '20px' }}>
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: `${progresso}%` }}
          ></div>
        </div>
        <img
          src={caminhonete}
          alt="Caminhão"
          style={{
            position: 'absolute',
            top: '-30px',
            left: `calc(${progresso}% - 25px)`,
            transition: 'left 0.3s ease-in-out',
            width: '50px'
          }}
        />

      </div>
      <div className="d-flex justify-content-between mt-2">
        {etapas.map((nome, index) => (
          <small
            key={index}
            className={`text-center ${etapaAtual === index ? 'fw-bold text-success' : ''}`}
            style={{ flex: 1, fontSize: '0.8rem' }}
          >

            {index + 1}. {nome}
          </small>
        ))}
      </div>
    </div>
  );
}

export default BarraProgresso;
